// CelebrationAnimation.jsx
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Confetti from 'react-confetti';

const CelebrationAnimation = ({ onComplete, registrationNumber }) => {
  const [showConfetti, setShowConfetti] = useState(true);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [copyMessage, setCopyMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login status

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
      onComplete();
    }, 8000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  const handleCopy = () => {
    navigator.clipboard.writeText(registrationNumber);
    setCopyMessage("Copied!");
    setTimeout(() => setCopyMessage(""), 2000);
  };

  // Function to handle close button click
  const handleClose = () => {
    setShowConfetti(false);
    onComplete();
  };

  const emojis = ['🎉', '✨', '🎊', '🥳', '🎈', '👏', '💫'];

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black bg-opacity-50">
      {showConfetti && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          recycle={false}
          numberOfPieces={500}
          gravity={0.2}
        />
      )}
      
      {/* Emoji poppers */}
      {Array.from({ length: 30 }).map((_, i) => {
        const emoji = emojis[Math.floor(Math.random() * emojis.length)];
        const duration = 3 + Math.random() * 2;
        const delay = Math.random() * 1.5;
        const left = `${Math.random() * 100}%`;
        
        return (
          <motion.div
            key={i}
            initial={{ y: -100, opacity: 0 }}
            animate={{ 
              y: windowSize.height + 100,
              opacity: [0, 1, 1, 0],
              rotate: [0, Math.random() * 360]
            }}
            transition={{
              duration,
              delay,
              ease: "linear"
            }}
            style={{
              position: 'absolute',
              left,
              fontSize: `${20 + Math.random() * 30}px`,
              zIndex: 2001
            }}
          >
            {emoji}
          </motion.div>
        );
      })}
      
      {/* Registration number display */}
      <div className="relative bg-white p-4 md:pt-5 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[450px]">
        {/* Close button */}
        <button 
          onClick={handleClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none"
          aria-label="Close"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-6 w-6" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <div className="flex flex-col items-center justify-center text-center h-full w-full">
          <div className="relative mb-4 w-full flex justify-center items-center">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
              alt="Success"
              className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
            />
            <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
              {isLoggedIn
                ? "Update Successful"
                : "Registration Successful"}
            </div>
          </div>
          <p className="text-black text-[10px] md:text-[32px] mb-2">
            {isLoggedIn
              ? "Your details have been updated successfully!"
              : `Thank you for registering with Farmnet`}
          </p>
          {!isLoggedIn && (
            <p className="text-black text-[10px] md:text-[32px] mb-4">
              Your unique registration number is:
            </p>
          )}
          {!isLoggedIn && (
            <div>
              <div className="flex-1 flex justify-center">
                <span className="text-[12px] md:text-[36px] font-bold text-center tracking-wide">
                  {registrationNumber}
                </span>
              </div>
            </div>
          )}
          <div className="flex items-center justify-between w-full mb-4 md:px-10">
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748558039/image_1738_biv82f.png" alt=".." className="md:w-[70px] w-[20px] h-[20px] md:h-[70px]"/>
            <button
              onClick={handleCopy}
              className="bg-[#EEB527] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]">
              Copy
            </button>
          </div>
          {copyMessage && (
            <div className="text-black text-[14px] md:text-[18px] font-semibold">
              {copyMessage}
            </div>
          )}
          <a href="/">
            <button
              className="bg-[#152C24] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[700px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
              Continue to Home
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default CelebrationAnimation;